import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AccountCircle, Logout, Settings } from '@mui/icons-material';
import { Avatar, IconButton, Menu, MenuItem, MenuList, Tooltip, Typography } from '@mui/material';

import { useAuth } from '../../../../providers/AuthProvider/hooks';
import { APP_WEB_ROUTES } from '../../../../routes/consts/routes';
import { NavMenuItem } from '../../../LeftMenu/components/LeftMenuItem/types/NavMenuItem';

const MENU_ITEMS: NavMenuItem[] = [
  {
    titleIcon: <Settings />,
    title: 'Settings',
  },
];

export default function UserMenu() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    signOut(() => {
      navigate(APP_WEB_ROUTES.login, { replace: true });
    });
  };

  return (
    <>
      <Tooltip title="Account">
        <IconButton onClick={onIconClick}>
          <Avatar />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} id="menu" open={!!anchorEl} onClose={onClose} onClick={onClose}>
        <MenuList>
          <MenuItem>
            <AccountCircle />
            <Typography sx={{ paddingLeft: '10px' }}>{user?.username}</Typography>
          </MenuItem>
          {MENU_ITEMS.map((item) => (
            <MenuItem key={item.title}>
              {item.titleIcon}
              <Typography sx={{ paddingLeft: '10px' }}>{item.title}</Typography>
            </MenuItem>
          ))}
          <MenuItem onClick={onLogoutClick}>
            <Logout />
            <Typography sx={{ paddingLeft: '10px' }}>{'Logout'}</Typography>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
